import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { TextFilter } from 'shared/components/filters/TextFilter';
import { debounce } from 'ts-debounce';
import { setControllingOrgFilter } from 'modules/settings/submodules/clients/controllingOrg/components/Filter/store/actions';

export const ControllingOrgFilter = () => {
    const dispatch = useDispatch();
    const debounceTimeout = 50;
    const changeFilter = useMemo(() =>
        debounce(
            (newFilterValue: string) => {
                dispatch(setControllingOrgFilter(newFilterValue || ''));
            },
            debounceTimeout),
    [dispatch],
    );
    return (
        <TextFilter onFilterValueChanged={changeFilter} />
    );
};
